export const PrintableCalendarFontSizes = {
  fontSize6: "6px",
  fontSize6v2: "6.5px",
  fontSize7: "7px",
  fontSize7v2: "7.5px",
  fontSize8: "8px",
  fontSize8v2: "8.5px",
  fontSize9: "9px",
  fontSize9v2: "9.5px",
  fontSize10: "10px",
  fontSize10v2: "10.5px",
  fontSize11: "11px",
  fontSize11v2: "11.5px",
  fontSize12: "12px",
  fontSize12v2: "12.5px",
  fontSize13: "13px",
  fontSize13v2: "13.5px",
  fontSize14: "14px",
  fontSize14v2: "14.5px",
  fontSize15: "15px",
  fontSize15v2: "15.5px",
  fontSize16: "16px",
  fontSize16v2: "16.5px",
  fontSize17: "17px",
  fontSize17v2: "17.5px",
  fontSize18: "18px",
  fontSize18v2: "18.5px",
  fontSize19: "19px",
  fontSize19v2: "19.5px",
  fontSize20: "20px",
  fontSize20v2: "20.5px",
  fontSize21: "21px",
  fontSize21v2: "21.5px",
  fontSize22: "22px",
  fontSize22v2: "22.5px",
  fontSize23: "23px",
  fontSize23v2: "23.5px",
  fontSize24: "24px",
  fontSize24v2: "24.5px",
  fontSize25: "25px",
  fontSize25v2: "25.5px",
  fontSize26: "26px",
  fontSize26v2: "26.5px",
  fontSize27: "27px",
  fontSize27v2: "27.5px",
  fontSize28: "28px",
  fontSize28v2: "28.5px",
  fontSize29: "29px",
  fontSize29v2: "29.5px",
  fontSize30: "30px",
  fontSize30v2: "30.5px",
  fontSize31: "31px",
  fontSize31v2: "31.5px",
  fontSize32: "32px",
  fontSize32v2: "32.5px",
  fontSize33: "33px",
  fontSize33v2: "33.5px",
  fontSize34: "34px",
  fontSize34v2: "34.5px",
  fontSize35: "35px",
  fontSize35v2: "35.5px",
  fontSize36: "36px",
  fontSize36v2: "36.5px",
  fontSize37: "37px",
  fontSize37v2: "37.5px",
  fontSize38: "38px",
  fontSize38v2: "38.5px",
  fontSize39: "39px",
  fontSize39v2: "39.5px",
  fontSize40: "40px",
  fontSize40v2: "40.5px",
  fontSize41: "41px",
  fontSize41v2: "41.5px",
  fontSize42: "42px",
  fontSize42v2: "42.5px",
  fontSize43: "43px",
  fontSize43v2: "43.5px",
  fontSize44: "44px",
  fontSize44v2: "44.5px",
  fontSize45: "45px",
  fontSize45v2: "45.5px",
  fontSize46: "46px",
  fontSize46v2: "46.5px",
  fontSize47: "47px",
  fontSize47v2: "47.5px",
  fontSize48: "48px",
  fontSize48v2: "48.5px",
  fontSize49: "49px",
  fontSize49v2: "49.5px",
  fontSize50: "50px",
};
